module.exports = __webpack_public_path__ + "media/images/stories-share-8ab55a12d232698c977e5e4da4c747f1.jpg";